import axios from 'axios';
import BaseAPI from './base/base-api';
import apiConfig from './apiConfig';

class OrganizationAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'organizations';

}

export default new OrganizationAPI();